export default {"src":"/_next/static/media/sent.dbfe1fa1.svg","height":159,"width":216,"blurWidth":0,"blurHeight":0};